import { toaster } from '@/components/ui/toaster';
import type {
  ConnectShopifyDto,
  ConnectShopifyResponse,
  GetShopifyInstallUrlResponse,
} from '@/services/integration-service';
import { connectShopify, getShopifyInstallUrl } from '@/services/integration-service';
import { useMutation } from '@tanstack/react-query';

/**
 * Hook to get Shopify install URL for compliant OAuth flow.
 * This replaces the manual shop entry flow.
 */
export const useGetShopifyInstallUrl = () => {
  return useMutation<GetShopifyInstallUrlResponse, Error>({
    mutationFn: async (): Promise<GetShopifyInstallUrlResponse> => {
      return await getShopifyInstallUrl();
    },
    onSuccess: (data) => {
      // Redirect to Shopify install page
      window.location.href = data.installUrl;
    },
    onError: (error: Error) => {
      console.error('Failed to generate install link:', error);

      toaster.error({
        title: 'Failed to generate install link',
        description: error.message || 'Failed to generate Shopify install link. Please try again.',
      });
    },
  });
};

/**
 * @deprecated Use useGetShopifyInstallUrl instead for compliant OAuth flow.
 * This hook uses an endpoint that violates Shopify App Store policy.
 */
export const useConnectShopifyAction = () => {
  return useMutation<ConnectShopifyResponse, Error, ConnectShopifyDto>({
    mutationFn: async (data: ConnectShopifyDto): Promise<ConnectShopifyResponse> => {
      return await connectShopify(data);
    },
    onError: (error: Error) => {
      console.error('Failed to connect Shopify:', error);

      toaster.error({
        title: 'Connection failed',
        description: error.message || 'Failed to connect to Shopify. Please try again.',
      });
    },
  });
};
